import { render, staticRenderFns } from "./MarginInput.vue?vue&type=template&id=467cc24c&"
import script from "./MarginInput.vue?vue&type=script&lang=js&"
export * from "./MarginInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports